module.exports = __webpack_public_path__ + "img/clear_icon.8b9a6c54.svg";